module.exports = __webpack_public_path__ + "assets/img/swisse2.ce5420ba.png";